import SolutionHeroI18n from "@/components/landing/shared/SolutionHeroI18n";
import { Handshake, Target, CalendarCheck, TrendingUp, Zap, UserCheck } from "lucide-react";
import heroImage from "@/assets/hero-person-vertrieb.png";

const VertriebHero = () => (
  <SolutionHeroI18n
    translationPrefix="vertriebSolution"
    heroImage={heroImage}
    floatingIcons={[
      { icon: Handshake, position: "top-[0%] left-[10%]", delay: "0s", duration: "3s", color: "orange" },
      { icon: Target, position: "top-[0%] right-[10%]", delay: "0.5s", duration: "3.5s", color: "mint" },
      { icon: CalendarCheck, position: "top-[30%] -left-[6%]", delay: "1s", duration: "4s", color: "primary" },
      { icon: TrendingUp, position: "top-[60%] -left-[4%]", delay: "1.5s", duration: "3.2s", color: "mint" },
      { icon: Zap, position: "bottom-[3%] left-[15%]", delay: "0.7s", duration: "3.8s", color: "orange" },
      { icon: UserCheck, position: "top-[25%] -right-[6%]", delay: "2s", duration: "3.6s", color: "primary" },
    ]}
    kpis={[
      { icon: UserCheck, labelKey: "kpiLeads", valueKey: "kpiLeadsValue", color: "text-chathero-mint" },
      { icon: CalendarCheck, labelKey: "kpiAppointments", valueKey: "kpiAppointmentsValue", color: "text-chathero-orange" },
      { icon: TrendingUp, labelKey: "kpiConversion", valueKey: "kpiConversionValue", color: "text-primary" },
    ]}
    barColor="bg-chathero-orange/60"
  />
);

export default VertriebHero;
